import { CalendarFrequency } from "@qendo/calendar";
import { ComboBox, type ComboBoxProps } from "~/components/form/combo-box/ComboBox";

export type FrequencyComboProps = {
    value: CalendarFrequency | null;
    onItemSelected: (value: CalendarFrequency | null) => void;
} & Omit<ComboBoxProps<CalendarFrequency>, "items" | "clearable">;

const items = Object.values(CalendarFrequency);

export const FrequencyCombo = ({
    name = "frequency",
    label = "Repeats",
    placeholder = "Never",
    ...comboProps
}: FrequencyComboProps) => {
    return (
        <ComboBox<CalendarFrequency>
            {...comboProps}
            name={name}
            label={label}
            placeholder={placeholder}
            items={items}
            clearable
        />
    );
};
